// PrivacyPolicy.js
import React from "react";
import "./LegalPages.css";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
 
  
} from 'react-icons/fa';


const PrivacyPolicy = () => {
  return (
    <div className="legal-page-container">
      <h1>Privacy Policy</h1>

      <section>
        <h2>1. Introduction</h2>
        <p>
          At <strong>Hiten Technologies</strong>, your privacy is important to us. This
          Privacy Policy explains how we collect, use, and protect your personal
          information when you interact with our website, products, and
          services. By using our Services, you agree to the terms of this
          Policy.
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>
            <strong>Personal Information:</strong> name, email address, phone
            number, and company details.
          </li>
          <li>
            <strong>Account Information:</strong> username, password, and
            preferences.
          </li>
          <li>
            <strong>Usage Data:</strong> pages visited, features used, and
            interactions with our Services.
          </li>
          <li>
            <strong>Technical Data:</strong> IP address, browser type, device
            details, and operating system.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Deliver and improve our products and services.</li>
          <li>Provide customer support and respond to inquiries.</li>
          <li>
            Send updates, offers, or communications (only when you consent).
          </li>
          <li>Ensure system security and prevent fraudulent activity.</li>
          <li>Comply with legal and regulatory requirements.</li>
        </ul>
      </section>

      <section>
        <h2>4. Sharing Your Information</h2>
        <p>
          We do <strong>not</strong> sell or rent your personal data. We may
          share information only in limited cases:
        </p>
        <ul>
          <li>
            With trusted third-party partners who assist in operating our
            services (e.g., hosting, analytics, or support).
          </li>
          <li>When required by law or to comply with legal processes.</li>
          <li>
            During a business transfer such as a merger, acquisition, or
            reorganization.
          </li>
        </ul>
      </section>

      <section>
        <h2>5. Cookies and Tracking</h2>
        <p>
          We use cookies and similar technologies to enhance your experience,
          analyze site traffic, and personalize content. You can manage your
          cookie preferences through your browser settings.
        </p>
      </section>

      <section>
        <h2>6. Data Security</h2>
        <p>
          We use reasonable technical and organizational measures to protect
          your data from unauthorized access, loss, or misuse. However, please
          note that no method of online transmission is completely secure.
        </p>
      </section>

      <section>
        <h2>7. Your Rights</h2>
        <p>
          Depending on your region, you may have the right to access, update, or
          delete your personal information, withdraw consent, or opt out of
          marketing communications.
        
          To exercise these rights, please reach out using the contact details
          below.
        </p>
      </section>

      <section>
        <h2>8. Policy Updates</h2>
        <p>
          We may update this Privacy Policy occasionally to reflect changes in
          our practices or legal requirements. Any updates will be posted on
          this page.
        </p>
      </section>

      <section>
        <h2>9. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy,
          please contact us:
        </p>
        <p>
          <FaEnvelope className="contact-icon" /><strong>Email:</strong> support@hitentechnologies.com <br />
          <FaPhone className="contact-icon" /><strong>Phone:</strong> +91 98904 13967 <br />
          <FaMapMarkerAlt className="contact-icon" /><strong>Address:</strong>  Flat No 304, B Wing, Rajveer Galaxy Sr No 3 Samarth Nagar Dighi, Pune, Maharashtra 411015
    
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
